export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7411.f812e560.jpg";